import { render, staticRenderFns } from "./ProductAcceptance.vue?vue&type=template&id=35620374&scoped=true&"
import script from "./ProductAcceptance.vue?vue&type=script&lang=js&"
export * from "./ProductAcceptance.vue?vue&type=script&lang=js&"
import style0 from "./ProductAcceptance.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProductAcceptance.vue?vue&type=style&index=1&id=35620374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35620374",
  null
  
)

export default component.exports